import gql from 'graphql-tag';

/**
 * Query to fetch all available credit types.
 *
 * @returns List of credit types with their ID and name
 * @usedIn Credits accordion, user directory, advertising flow
 */
export const CREDIT_TYPES = gql`
  query {
    creditTypes {
      typeId
      typeName
      typeDescription
    }
  }
`;
